import { render, staticRenderFns } from "./GoogleLogin.vue?vue&type=template&id=58ab5938&scoped=true"
import script from "./GoogleLogin.vue?vue&type=script&lang=js"
export * from "./GoogleLogin.vue?vue&type=script&lang=js"
import style0 from "./GoogleLogin.vue?vue&type=style&index=0&id=58ab5938&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58ab5938",
  null
  
)

export default component.exports